<template>
  <div id="app">
    <Layout
      v-if="isMall"
      :is-mail-pro="false"
      v-bind="permission"
    >
      <div
        slot="header-custom"
        class="name"
      >
        {{ text }}
      </div>
      <xm-header slot="header-right" />
      <div class="xm-container">
        <auth-message v-if="!isJapan" />
        <xm-sidebar v-if="!isJapan" />
        <div class="xm-content">
          <router-view />
        </div>
      </div>
    </Layout>
    <router-view
      class="export-container"
      v-else-if="isExport"
    />
    <router-view
      class="appointment-container"
      v-else-if="isAppointment"
    />
    <router-view v-else-if="noLogin" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Layout from "@libs/riven/src/index";
import EventBus from "@utils/eventBus";
import XmHeader from "@components/XmHeader";
import XmSidebar from "@components/XmSidebar";
import AuthMessage from "@components/AuthMessage";
import {
  XIAOMAN_VERTIFY,
  FADADA_VERTIFY,
  NO_APPOINTMENT,
  APPOINTMENT_NOT_IMPLETE,
  IMPLETE_SUCCESS,
  CANNOT_APPOINTMENT,
} from "@utils/constants";
import {transferHost} from "./utils/transferHost";

export default {
  data() {
    return {
      isMall: false,
      isExport: false,
      isAppointment: false,
    };
  },
  computed: {
    ...mapState("main", {
      permission: (state) => state.permission,
      isClientActive: (state) => state.isClientActive,
    }),
    ...mapGetters("main", ["isAdmin", "isTaiwanClient"]),
    ...mapGetters("appointment", ["appointmentStatus"]),
    noLogin: {
      get() {
        //不需要获取用户信息 免登录的页面
        const paymentPaths = ['payment', 'register']
        return paymentPaths.some((a) => window.location.pathname.includes(a));
      },
      set() {},
    },
    text: {
      get() {
        return this.$t("sideBar.site");
      },
    },
    isJapan() {
      return window.location.host.includes('okki.ai')
    },
  },
  async created() {
    //支付页面不需要获取用户信息 免登录
    if (!this.noLogin) {
      await this.fetchUserInfo();
      transferHost(this.isTaiwanClient)
    }
    // this.fetchPermission();
  },
  watch: {
    $route(to) {
      const path = to.path.toLowerCase();
      if (path === "/mainlandauth" || path === "/auth") {
        this.fetchUserInfo().then((data) => {
          const { verification_type } = data.verification;
          if (
            (verification_type === XIAOMAN_VERTIFY &&
              path === "/mainlandauth") ||
            (verification_type === FADADA_VERTIFY && path === "/auth")
          ) {
            this.$router.replace("/home");
          }
        });
      }
      this.isAppointment = path.indexOf("appoint") !== -1;
      this.isExport = path.indexOf("export") !== -1;
      this.isMall = !this.isAppointment && !this.isExport && !this.noLogin;
      if (this.isAppointment) {
        this.fetchAppointmentList().then(() => {
          this.initStatusPage();
        });
      }
    },
    isClientActive(val) {
      if (val && !this.isExport) {
        this.fetchPermission();
      }
    },
  },
  mounted() {
    EventBus.$emit("app-load");
  },
  methods: {
    ...mapActions("main", ["fetchUserInfo", "fetchPermission"]),
    ...mapActions("appointment", ["fetchAppointmentList"]),
    initStatusPage() {
      if (!this.isAdmin) {
        this.$router.replace({
          name: "AppointAccountTip",
        });
        return;
      }
      const pageMap = {
        [NO_APPOINTMENT]: "AppointList",
        [APPOINTMENT_NOT_IMPLETE]: "AppointCancel",
        [IMPLETE_SUCCESS]: "AppointSuccess",
        [CANNOT_APPOINTMENT]: "AppointSuccess",
      };
      this.$router.replace({
        name: pageMap[this.appointmentStatus],
      });
    },
  },
  components: {
    Layout,
    XmHeader,
    XmSidebar,
    AuthMessage,
  },
};
</script>
<style lang="scss" scoped>
.name {
  font-size: 14px;
}
.xm-container {
  position: relative;
  width: 100%;
  padding-left: 200px;
}
.xm-content {
  position: relative;
  width: 920px;
  margin: 62px auto 55px;
  border-radius: 6px;
  background: #fff;
}
.appointment-container,
.export-container {
  width: 1034px;
  min-height: 583px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
